// 行別モード（五十音の「あかさたなはまやらわ」行）
// 横キー・縦キーとは別メニューで、行を選んでその行のローマ字を練習する用
export const TYPING_MODE_KEYS_GYOU = {
  a: {
    name: 'あ行',
    keys: ['A', 'I', 'U', 'E', 'O']
  },
  ka: {
    name: 'か行',
    keys: ['KA', 'KI', 'KU', 'KE', 'KO']
  },
  sa: {
    name: 'さ行',
    keys: ['SA', 'SHI', 'SU', 'SE', 'SO']
  },
  ta: {
    name: 'た行',
    keys: ['TA', 'CHI', 'TSU', 'TE', 'TO']
  },
  na: {
    name: 'な行',
    keys: ['NA', 'NI', 'NU', 'NE', 'NO']
  },
  ha: {
    name: 'は行',
    keys: ['HA', 'HI', 'FU', 'HE', 'HO']
  },
  ma: {
    name: 'ま行',
    keys: ['MA', 'MI', 'MU', 'ME', 'MO']
  },
  ya: {
    name: 'や行',
    keys: ['YA', 'YU', 'YO']
  },
  ra: {
    name: 'ら行',
    keys: ['RA', 'RI', 'RU', 'RE', 'RO']
  },
  wa: {
    name: 'わ行',
    keys: ['WA', 'WO', 'N']
  }
};
